import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AttributeListFailuresGroupedTable from './AttributeListFailuresGroupedTable';
import FlowListFailuresGroupedTable from './FlowListFailuresGroupedTable';

export default function GroupDetailsFailuresGroupedTable({
  groupKey,
  flows = [],
  attributes = [],
}) {
  const sections = [
    {
      key: `${groupKey}-flows`,
      label: 'Flows',
      count: flows.length,
      countLabel: `${flows.length} flows`,
      content: <FlowListFailuresGroupedTable flows={flows} />,
    },
    {
      key: `${groupKey}-attributes`,
      label: 'Attributes',
      count: attributes.length,
      countLabel: `${attributes.length} attributes`,
      content: <AttributeListFailuresGroupedTable attributes={attributes} groupKey={groupKey} />,
    },
  ];

  return (
    <Box>
      {sections.map((section) => (
        <Accordion key={section.key} disableGutters variant="outlined" sx={{ mb: 1 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                width: '100%',
                pr: 1,
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: 800 }}>
                {section.label}
              </Typography>
              <Chip
                label={section.countLabel}
                size="small"
                color={section.count > 0 ? 'primary' : 'default'}
                variant="outlined"
              />
            </Box>
          </AccordionSummary>
          <AccordionDetails>{section.content}</AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
}
